export const getLatLngFromGoogleMaps = async (search: string): Promise<{ lat: number; lng: number } | null> => {
  const apiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
  if (!apiKey) return null;

  try {
    const response = await fetch(
      `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(search + ', VIC, Australia')}&region=au&key=${apiKey}`
    );
    const data = await response.json();

    if (data.status === 'OK') {
      const { lat, lng } = data.results[0].geometry.location;
      return { lat, lng };
    } else {
      console.warn('Geocoding failed:', data.status);
      return null;
    }
  } catch (error) {
    console.error('Error calling Geocoding API:', error);
    return null;
  }
};